import {
  GET_PURCHASE_ORDERS, GET_PURCHASE_ORDERS_COMPLETED, GET_PURCHASE_ORDERS_FAILED,
  GET_PURCHASE_ORDER, GET_PURCHASE_ORDER_COMPLETED, GET_PURCHASE_ORDER_FAILED,
  ADD_PURCHASE_ORDER, ADD_PURCHASE_ORDER_COMPLETED, ADD_PURCHASE_ORDER_FAILED,
  ADD_PRODUCT_TO_PURCHASE_ORDER, ADD_PRODUCT_TO_PURCHASE_ORDER_COMPLETED, ADD_PRODUCT_TO_PURCHASE_ORDER_FAILED,
  REMOVE_PRODUCT_FROM_PURCHASE_ORDER, REMOVE_PRODUCT_FROM_PURCHASE_ORDER_COMPLETED, REMOVE_PRODUCT_FROM_PURCHASE_ORDER_FAILED,
  UPDATE_PURCHASE_ORDER_PRODUCT, UPDATE_PURCHASE_ORDER_PRODUCT_COMPLETED, UPDATE_PURCHASE_ORDER_PRODUCT_FAILED,
  SUBMIT_PURCHASE_ORDER, SUBMIT_PURCHASE_ORDER_COMPLETED, SUBMIT_PURCHASE_ORDER_FAILED,
  CONFIRM_PURCHASE_ORDER, CONFIRM_PURCHASE_ORDER_COMPLETED, CONFIRM_PURCHASE_ORDER_FAILED,
  RECEIVE_PURCHASE_ORDER, RECEIVE_PURCHASE_ORDER_COMPLETED, RECEIVE_PURCHASE_ORDER_FAILED,
  CANCEL_PURCHASE_ORDER, CANCEL_PURCHASE_ORDER_COMPLETED, CANCEL_PURCHASE_ORDER_FAILED,
  SEARCH_PURCHASE_ORDERS, SEARCH_PURCHASE_ORDERS_COMPLETED, SEARCH_PURCHASE_ORDERS_FAILED,
} from './actions';
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  purchaseOrdersLoading: false,
  purchaseOrders: [],
  purchaseOrdersError: null,
  purchaseOrderLoading: false,
  purchaseOrder: null,
  purchaseOrderError: null,
  addPurchaseOrderLoading: false,
  addProductToPurchaseOrderLoading: false,
  removeProductFromPurchaseOrderLoading: false,
  updatePurchaseOrderProductLoading: false,
  submitPurchaseOrderLoading: false,
  confirmPurchaseOrderLoading: false,
  receivePurchaseOrderLoading: false,
  cancelPurchaseOrderLoading: false,
  search: searchDefault,
};

const purchaseOrderReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_PURCHASE_ORDERS: return handleSearch(state, 'search', action.payload);
    case SEARCH_PURCHASE_ORDERS_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_PURCHASE_ORDERS_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_PURCHASE_ORDERS: {
      return {
        ...state,
        purchaseOrdersLoading: true,
        purchaseOrders: [],
        purchaseOrdersError: null,
      };
    }
    case GET_PURCHASE_ORDERS_COMPLETED: {
      return {
        ...state,
        purchaseOrdersLoading: false,
        purchaseOrders: action.payload.data,
      };
    }
    case GET_PURCHASE_ORDERS_FAILED: {
      return {
        ...state,
        purchaseOrdersLoading: false,
        purchaseOrdersError: action.payload,
      };
    }
    case GET_PURCHASE_ORDER: {
      return {
        ...state,
        purchaseOrderLoading: true,
        purchaseOrder: null,
        purchaseOrderError: null,
      };
    }
    case GET_PURCHASE_ORDER_COMPLETED: {
      return {
        ...state,
        purchaseOrderLoading: false,
        purchaseOrder: action.payload,
      };
    }
    case GET_PURCHASE_ORDER_FAILED: {
      return {
        ...state,
        purchaseOrderLoading: false,
        purchaseOrderError: action.payload,
      };
    }
    case ADD_PURCHASE_ORDER: {
      return {
        ...state,
        addPurchaseOrderLoading: true,
      };
    }
    case ADD_PURCHASE_ORDER_COMPLETED: {
      return {
        ...state,
        addPurchaseOrderLoading: false,
      };
    }
    case ADD_PURCHASE_ORDER_FAILED: {
      return {
        ...state,
        addPurchaseOrderLoading: false,
      };
    }
    case ADD_PRODUCT_TO_PURCHASE_ORDER: {
      return {
        ...state,
        addProductToPurchaseOrderLoading: true,
      };
    }
    case ADD_PRODUCT_TO_PURCHASE_ORDER_COMPLETED: {
      return {
        ...state,
        addProductToPurchaseOrderLoading: false,
      };
    }
    case ADD_PRODUCT_TO_PURCHASE_ORDER_FAILED: {
      return {
        ...state,
        addProductToPurchaseOrderLoading: false,
      };
    }
    case REMOVE_PRODUCT_FROM_PURCHASE_ORDER: {
      return {
        ...state,
        removeProductFromPurchaseOrderLoading: true,
      };
    }
    case REMOVE_PRODUCT_FROM_PURCHASE_ORDER_COMPLETED: {
      return {
        ...state,
        removeProductFromPurchaseOrderLoading: false,
      };
    }
    case REMOVE_PRODUCT_FROM_PURCHASE_ORDER_FAILED: {
      return {
        ...state,
        removeProductFromPurchaseOrderLoading: false,
      };
    }
    case UPDATE_PURCHASE_ORDER_PRODUCT: {
      return {
        ...state,
        updatePurchaseOrderProductLoading: true,
      };
    }
    case UPDATE_PURCHASE_ORDER_PRODUCT_COMPLETED: {
      return {
        ...state,
        updatePurchaseOrderProductLoading: false,
      };
    }
    case UPDATE_PURCHASE_ORDER_PRODUCT_FAILED: {
      return {
        ...state,
        updatePurchaseOrderProductLoading: false,
      };
    }
    case SUBMIT_PURCHASE_ORDER: {
      return {
        ...state,
        submitPurchaseOrderLoading: true,
      };
    }
    case SUBMIT_PURCHASE_ORDER_COMPLETED: {
      return {
        ...state,
        submitPurchaseOrderLoading: false,
      };
    }
    case SUBMIT_PURCHASE_ORDER_FAILED: {
      return {
        ...state,
        submitPurchaseOrderLoading: false,
      };
    }
    case CONFIRM_PURCHASE_ORDER: {
      return {
        ...state,
        confirmPurchaseOrderLoading: true,
      };
    }
    case CONFIRM_PURCHASE_ORDER_COMPLETED: {
      return {
        ...state,
        confirmPurchaseOrderLoading: false,
      };
    }
    case CONFIRM_PURCHASE_ORDER_FAILED: {
      return {
        ...state,
        confirmPurchaseOrderLoading: false,
      };
    }
    case RECEIVE_PURCHASE_ORDER: {
      return {
        ...state,
        receivePurchaseOrderLoading: true,
      };
    }
    case RECEIVE_PURCHASE_ORDER_COMPLETED: {
      return {
        ...state,
        receivePurchaseOrderLoading: false,
      };
    }
    case RECEIVE_PURCHASE_ORDER_FAILED: {
      return {
        ...state,
        receivePurchaseOrderLoading: false,
      };
    }
    case CANCEL_PURCHASE_ORDER: {
      return {
        ...state,
        cancelPurchaseOrderLoading: true,
      };
    }
    case CANCEL_PURCHASE_ORDER_COMPLETED: {
      return {
        ...state,
        cancelPurchaseOrderLoading: false,
      };
    }
    case CANCEL_PURCHASE_ORDER_FAILED: {
      return {
        ...state,
        cancelPurchaseOrderLoading: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default purchaseOrderReducer;



// WEBPACK FOOTER //
// ./src/PurchaseOrder/reducer.js